/** @format */

import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useStylesTopbar } from './style';
import {
  Icons
} from 'components';
import { AppBar, Toolbar, Hidden, IconButton, Grid } from '@mui/material';
import { AuthService } from 'components/Auth';
import { useBusiness } from 'hooks';
import UserMenu from './UserMenu';

const Topbar = (props) => {
  const { onSidebarOpen, ...rest } = props;
  const [isLoading, setIsLoading] = useState(false);

  const classes = useStylesTopbar();

  const Business = useBusiness();

  const signOut = async () => {
    setIsLoading(true);
    try {
      const res = await AuthService.logout();
      setTimeout(() => {
        AuthService.clearToken();
      }, 10);
      window.location.href = res.result;
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      window.location.href = './sign-in';
    }
  };

  return (
    <AppBar {...rest} className={classes.root}>
      <Hidden lgUp>
        <Grid
          container
          justifyContent="flex-start"
          className={classes.menuIconContainer}
          alignItems="center"
        >
          <IconButton color="primary" onClick={onSidebarOpen} size="large">
            <Icons icon='Hamburger' color='#2B3990' size='28' />
          </IconButton>
        </Grid>
      </Hidden>
      <Hidden lgUp>
        <Grid container justifyContent="center" className={classes.respLogoContainer} alignItems="center">
          <RouterLink to="/Home" className={classes.logoLight}>
            <img alt="Logo" className={classes.logo} src="./images/pod/main-persian.svg" />
          </RouterLink>
        </Grid>
      </Hidden>
      <Hidden lgDown>
        <Grid container justifyContent="flex-start" alignItems="center">
          <Grid className={classes.panelTitle}>پنل مدیریت کسب‌و‌کار</Grid>
        </Grid>
      </Hidden>
      <Toolbar
        style={{
          width: '30vw',
          padding: 0,
          minHeight: 'auto',
          justifyContent: 'flex-end',
        }}
      >
        <UserMenu business={Business} signOut={signOut} isLoading={isLoading} />
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func,
};

export default Topbar;
